import { Transparency } from 'domains/models/event/transparency';
import { getDateTime } from 'infras/datetime';
import { TimeListItem } from 'presentations/api/helpers/event_type';
import { UnavailableInfomation } from 'presentations/api/schema/calendar_event';
import { SharedGuestUserItem } from 'presentations/api/schema/user';

type Props = {
  date: string;
  timeZone: string;
  timeListItem: TimeListItem;
  duration: number;
};
export const useTimeList = ({
  date,
  timeZone,
  timeListItem,
  duration,
}: Props) => {
  const hour = typeof timeListItem[0] === 'number' ? timeListItem[0] : 0;
  const minute = typeof timeListItem[1] === 'number' ? timeListItem[1] : 0;
  const calendarEvent = timeListItem[2] ? timeListItem[2] : null;
  const remainingCapacity =
    typeof timeListItem[3] === 'number' ? timeListItem[3] : null;
  const guestUsers = (Array.isArray(timeListItem[4])
    ? timeListItem[4]
    : []) as SharedGuestUserItem[];
  const unavailableInfomations = (Array.isArray(timeListItem[5])
    ? timeListItem[5]
    : []) as UnavailableInfomation[];
  const isTransparentEvent = timeListItem[6]
    ? timeListItem[6] === Transparency.Transparent
    : false;

  const startDateTime = getDateTime(date, timeZone).set({ hour, minute });
  const endDateTime = startDateTime.plus({ minutes: duration });

  const uniqueUnavailableInfomations: UnavailableInfomation[] = [];
  if (unavailableInfomations) {
    for (const reason of unavailableInfomations) {
      if (
        uniqueUnavailableInfomations.find((uui) => uui.reason === reason.reason)
      ) {
        continue;
      }
      uniqueUnavailableInfomations.push(reason);
    }
  }
  const hasUnavailableInfomation = uniqueUnavailableInfomations.length > 0;
  const isCapacityFull = remainingCapacity === 0;

  return {
    date: startDateTime,
    startTimeText: startDateTime.toFormat('H:mm'),
    endTimeText: endDateTime.toFormat('H:mm'),
    calendarEvent,
    remainingCapacity,
    isCapacityFull,
    guestUsers,
    hasUnavailableInfomation,
    unavailableInformations: uniqueUnavailableInfomations,
    isTransparentEvent,
  };
};
